module.exports = __webpack_public_path__ + "img/hatartalan_microsite_main_v7.399faf0c.png";